// middleware.js
import {openPrimaryWorkspace, openSecondaryWorkspace } from "../../reducers/workspaceSlice"
import { getAllUnassignedArticles, getUnassignedArticles } from "../../reducers/unassignedArticlesEventsSlice" 

const fetchUnassignedArticlesMiddleware = store => next => action => {
	if (
		action.type === openPrimaryWorkspace.fulfilled.type ||
		action.type === openSecondaryWorkspace.fulfilled.type
	) {
		const workspaceId = action.payload.workspace.id
		store.dispatch(getUnassignedArticles(workspaceId))
		store.dispatch(getAllUnassignedArticles(workspaceId))
	}
	return next(action)
}

export default fetchUnassignedArticlesMiddleware
